<template>
    <div class="actions-modal">
        <div class="ui-dropdown">
            <div class="ui-dropdown__menu">
                <ul class="ui-dropdown-menu">
                    <slot></slot>
                </ul>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">

</script>

<style scoped lang="scss">
    @use 'ActionsModal' as *;
</style>
